import { createSelector } from 'reselect';
import * as R from 'ramda';

const emptyArray = [];

export const getOperators = () => createSelector(
    ({ geo }, { countryID }) => geo.getIn(['operators', countryID]),
    R.ifElse(Boolean, (list) => list.toArray(), R.always(emptyArray))
);
